import { tv } from "@ui/lib/tv";
import { type PopoverProps, Popover as RACPopover } from "@ui/primitives/Popover";
import { composeRenderProps } from "@ui/primitives/shared";

/**
 * The floating popover card chrome: white 20px-radius surface on the popover
 * elevation token, entering/exiting with a fade+zoom. Shared by
 * `PopoverSurface` and `HoverCard`.
 */
export const popoverSurface = tv({
  base: [
    "rounded-3xl bg-white shadow-md",
    "will-change-transform",
    "entering:fade-in entering:zoom-in-95 entering:animate-in entering:duration-200 entering:ease-out",
    "exiting:fade-out exiting:zoom-out-95 exiting:animate-out exiting:duration-150 exiting:ease-in",
  ],
});

export interface PopoverSurfaceProps extends PopoverProps {}

/**
 * Styled popover shell over the Popover primitive: the standard floating card
 * surface for trigger-anchored overlays (e.g. the notification panel). Width
 * and padding come from the content or `className`; placement and trigger
 * wiring are the primitive's own props.
 */
export function PopoverSurface(props: PopoverSurfaceProps) {
  return (
    <RACPopover
      {...props}
      className={composeRenderProps(props.className, (className) => popoverSurface({ className }))}
    />
  );
}
